'use client';

import { createClient as createSupabaseClient } from '@supabase/supabase-js';

// Hardcoded correct Supabase URL — env var was resolving to wrong value (one 't') at build time
const SUPABASE_URL = 'https://vjzttfqsvrachqkgnedv.supabase.co';
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!;

if (!supabaseAnonKey) {
  console.error('[Supabase] Missing NEXT_PUBLIC_SUPABASE_ANON_KEY');
} else {
  console.log('[Supabase] Initializing with URL:', SUPABASE_URL);
}

// Singleton instance — prevents re-creating the client on every render
// Uses localStorage (not cookies) so session persists in iframes/preview environments
let client: ReturnType<typeof createSupabaseClient> | null = null;

export function createClient() {
  if (client) return client;
  client = createSupabaseClient(SUPABASE_URL, supabaseAnonKey, {
    auth: {
      persistSession: true,
      storageKey: 'catalyst-auth-token',
      storage: typeof window !== 'undefined' ? window.localStorage : undefined,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  });
  return client;
}

/** Call this after sign-out so the next createClient() returns a fresh instance */
export function resetClient() {
  client = null;
}
